export { default } from './InfoBox';



// WEBPACK FOOTER //
// ./src/design-system/atoms/InfoBox/index.jsx